// What a Square timecard sync actually did, in a sentence a manager can act on.
//
// A manager, 2026-08-17: "ally forgot to clock in on 8/15 but was on time. I
// switched it to 5:30am in square but when I refresh on monarch it is still
// saying 6:01 for that date. Tried hitting refresh import from square and it
// does not adjust."
//
// Production that afternoon: four syncs, all HTTP 200 —
//
//   15:27:40 · 15:28:25 · 15:30:00   wrote ZERO punches between them
//   16:13:47                          wrote 153, and fixed the 05:30
//
// The panel discarded the response and said "Pulled latest from Square." every
// time. The route reports per-location failures INSIDE a 200 body (it collects
// errors rather than throwing), so the status code alone cannot tell a real
// import from one that did nothing at all. Three times in four minutes, a
// manager was told it worked while nothing moved.
//
// Kept out of the panel because TimecardReviewPanel.jsx sits at its recorded
// line ceiling, and because a pure function is testable by calling it rather
// than by grepping JSX for strings.

/**
 * @param {{results?: Array<{location?: string, error?: string,
 *          imported?: number, replaced?: number}>}} result
 * @returns {{ok: boolean, text: string}} ok=true only when timecards moved.
 */
export function summarizeSquareSync(result) {
  const rows = Array.isArray(result?.results) ? result.results : [];
  const failed = rows.filter((r) => r && r.error);
  if (failed.length) {
    const who = failed.map((r) => r.location || 'a location').join(', ');
    return { ok: false, text: `Square failed for ${who} — ${failed[0].error}` };
  }
  const imported = rows.reduce((n, r) => n + (Number(r?.imported) || 0), 0);
  const replaced = rows.reduce((n, r) => n + (Number(r?.replaced) || 0), 0);
  if (imported === 0) {
    // The silent case, and the one that sent a manager hunting. "Square had
    // nothing for this week" is a different problem from "the edit did not
    // save", and the message has to leave both on the table.
    return {
      ok: false,
      text: 'Square returned no timecards for this week — nothing changed. '
          + 'Check you are on the right week and that the edit saved in Square.',
    };
  }
  return {
    ok: true,
    text: `Pulled ${imported} timecard${imported === 1 ? '' : 's'} from Square`
        + `${replaced ? `, replaced ${replaced}` : ''}.`,
  };
}
